"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAccordion = getMuiAccordion;
exports.getMuiAccordionSummary = getMuiAccordionSummary;
function getMuiAccordion() {
  return {
    styleOverrides: {
      root: function (_ref) {
        var theme = _ref.theme;
        return {
          '&.Mui-disabled': {
            backgroundColor: theme.palette.gray[50],
            borderColor: theme.palette.gray[200]
          },
          background: theme.palette.common.white,
          borderRadius: '16px',
          borderWidth: '1px'
        };
      }
    }
  };
}
function getMuiAccordionSummary() {
  return {
    styleOverrides: {
      root: function (_ref2) {
        var theme = _ref2.theme;
        return {
          '&.Mui-disabled': {
            '.MuiTypography-root': {
              color: theme.palette.gray[400]
            }
          },
          '.MuiTypography-root': {
            color: theme.palette.gray[900]
          }
        };
      }
    }
  };
}